import { SplatArea } from '../SplatArea';
import calculatePropertiesForPencil from '../splat/calculatePropertiesForPencil';
import calculateSplatForPencil from '../splat/calculateSplatForPencil';
import Splat from './SingleSplat';

class SplatPencil extends Splat {
  update(settings) {
    this.settings = settings;

    this.properties = calculatePropertiesForPencil(this.settings);

    console.log('Pencil splat properties calculated');
  }

  splat(_pressure, simulationArea) {
    let runSplatVelocityProgram = false;

    if (!simulationArea) {
      this.splatAreas.splice(0, 0, new SplatArea(this.getCurrentBrushArea(), this.frameNumber));
      simulationArea = this.getSimulationArea();

      runSplatVelocityProgram = true;
    }

    this.currentSizePerSegment = this.settings.depletionFunction(this.brush.splatsPerSegment, this.brush.getAvgSpeed());

    const splatSettings = calculateSplatForPencil(_pressure, this.depletionCoefficient, this.properties, this.settings);

    this.cleanGl();

    this.runSplatProgram(simulationArea, splatSettings.splatRadius, splatSettings.color, splatSettings.zThreshold);

    // skip simulation
    if (runSplatVelocityProgram) {
      this.runSplatVelocityProgram(simulationArea, splatSettings.splatRadius, splatSettings.splatVelocityScale, splatSettings.zThreshold);
    }

    return simulationArea;
  }
}

export default SplatPencil;
